import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class LbToEpDecAuthService {



  constructor(private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
  
      if ((localStorage.getItem('userType') === '2') &&
      ((localStorage.getItem('roleId') === '1') || (localStorage.getItem('roleId') === '3') 
    || (localStorage.getItem('roleId') === '4') || (localStorage.getItem('roleId') === '7')
    || (localStorage.getItem('roleId') === '8'))) {
      return true;
    }  else {
      this.router.navigate(['/userview/dashboard']);
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/AUTHGAURD/lb-to-ep-dec-auth.service.ts